import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { GoogleAuthService } from './google-auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private authStateSubject = new BehaviorSubject<boolean>(false);
  public authState$: Observable<boolean> = this.authStateSubject.asObservable();
  
  constructor(
    private router: Router,
    private googleAuthService: GoogleAuthService
  ) {
    // Subscribe to the new Google Auth Service state
    this.googleAuthService.authState$.subscribe(isLoggedIn => {
      this.authStateSubject.next(isLoggedIn);
    });
    
    // Initialize auth state from localStorage for backward compatibility
    const userExists = !!localStorage.getItem('googleUser') || this.googleAuthService.isLoggedIn();
    this.authStateSubject.next(userExists);
  }
  
  logout(): void {
    // Clear old localStorage items for backward compatibility
    localStorage.removeItem('googleUser');
    localStorage.removeItem('userRole');
    
    // Use the new Google Auth Service logout
    this.googleAuthService.logout();
    
    // Update the auth state
    this.authStateSubject.next(false);
    // Navigate to home page after logout
    this.router.navigate(['/']);
  }
  
  // Method to check if user is logged in
  isLoggedIn(): boolean {
    return this.googleAuthService.isLoggedIn() || !!localStorage.getItem('googleUser');
  }
  
  // Method to notify about login state changes
  notifyLogin(): void {
    this.authStateSubject.next(true);
  }

  // Backward compatibility method to get user role
  getUserRole(): string | null {
    const role = this.googleAuthService.getCurrentUserRole();
    if (role) {
      return role;
    }
    // Fallback to localStorage for backward compatibility
    return localStorage.getItem('userRole');
  }

  // Backward compatibility method to get user info
  getUserInfo(): any {
    const user = this.googleAuthService.getCurrentUser();
    if (user) {
      return user;
    }
    // Fallback to localStorage for backward compatibility
    const storedUser = localStorage.getItem('googleUser');
    return storedUser ? JSON.parse(storedUser) : null;
  }
}
